<app-loading *ngIf="isLoading"></app-loading>
<div id="embedReport" class="report-frame"></div>
